import { useCallback, useSyncExternalStore } from 'react'
import { usePortalAiClient } from '#src/api/ai.ts'
import {
  beginMcpAuthorization,
  clearMcpTokens,
  isMcpConnected,
  subscribeMcpConnection,
} from '#src/mcp/mintMcp.ts'

export interface MintMcpConnection {
  connected: boolean
  /** Redirects the browser to the MCP authorization server. */
  connect: () => Promise<void>
  /** Forgets the stored tokens; the next turn runs without MCP tools. */
  disconnect: () => void
}

export function useMintMcpConnection(): MintMcpConnection {
  const client = usePortalAiClient()
  const connected = useSyncExternalStore(
    subscribeMcpConnection,
    isMcpConnected,
    () => false
  )
  const connect = useCallback(() => beginMcpAuthorization(client), [client])
  const disconnect = useCallback(() => clearMcpTokens(), [])
  return { connected, connect, disconnect }
}
